// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/form.yaml
// 生成时间: 2026-08-28T07:43:12.569Z
import http from '../http';

export default {
  // 获取列表 form.list
  list: (data) => http.post('formbuilder/applyform/page', data),

  // 获取单个表单信息 form.info
  info: (params) => http.get('formbuilder/applyform/get/' + params),

  // 保存或者更新表单信息 form.save
  save: (data) => http.post('formbuilder/applyform/save', data),

  // 删除表单 form.del
  del: (params) => http.post('formbuilder/applyform/remove?id=' + params),

  field: {
    // 字段列表 form.field.list
    list: (data) => http.get('content-service/field/list', data),

    // 保存字段 form.field.save
    save: (data) => http.post('content-service/field/save', data),

    // 删除字段 form.field.del
    del: (data) => http.get('content-service/field/delete', data),
  },

  // 合并表单 form.margeForm
  margeForm: (data) => http.post('formbuilder/statistics/save', data),

  // 合并表单列表 form.margeFormList
  margeFormList: (data) => http.post('formbuilder/statistics/list', data),

  // 下载列表 form.downloadList
  downloadList: (data) => http.post('formbuilder/statistics/export', data),

  // 执行 form.getExecute
  getExecute: (data) => http.post('formbuilder/statistics/get', data),

  // 更新状态 form.updateStatus
  updateStatus: (params) => http.post('formbuilder/applyform/update/status?id=' + params.id + '&status=' + params.status),

  // 复制表单 form.copy
  copy: (data) => http.post('formbuilder/applyform/copy', data),

  // 导入数据 form.importData
  importData: (data) => http.post('formbuilder/applyFormSubmit/import/sumbit', data),

  // 获取报表的头部 form.reportHeader
  reportHeader: (params) => http.post('formbuilder/applyform/head?form_id=' + params.id),

  // 获取分页 form.getReportPages
  getReportPages: (data) => http.post('formbuilder/applyform/submit/page/list', data),

  // 表单模板 form.getInsertTemp
  getInsertTemp: (params) => http.post('formbuilder/applyFormSubmit/export/template?formId=' + params.id),
};
